import React, { useMemo, useRef } from 'react'
import { connect } from 'react-redux'
import { SubmissionError } from 'redux-form'
import QS from 'qs'
import { useTranslation } from 'react-i18next'

import {
  setCurrentUserToken,
  setCurrentUserAuthProvider,
} from 'ducks/users/index.ts'
import { validateOtp, authFinalize } from 'utils/io'

import AuthPage from './AuthV2/AuthPage.tsx'

import './Auth.scss'
import TwoFactorAuthLoginForm from './AuthV2/TwoFactorAuthLoginForm'

const TwoFactorAuthLogin = props => {
  const { t } = useTranslation()
  const { location, history, setCurrentUserToken, setCurrentUserAuthProvider } =
    props

  const credentialsRef = useRef('')

  useMemo(() => {
    const stored = localStorage.getItem('twoFactorData')

    if (!stored) {
      history.push('/login')

      return
    }

    try {
      credentialsRef.current = stored
      localStorage.removeItem('twoFactorData') // clean up
    } catch (err) {
      history.push('/login')
    }
  }, [])

  const redirect = useMemo(() => {
    const { redirect } = QS.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    return redirect
  }, [location])

  const handle2FASubmit = async ({ authCode }) => {
    try {
      const response = await validateOtp({
        authCode,
        attemptToken: credentialsRef.current,
      })

      if (response.success) {
        const finalized = await authFinalize({
          attemptToken: response.attemptToken,
        })

        setCurrentUserToken(finalized.sessionToken)
        setCurrentUserAuthProvider(finalized.lastUsedAuthProvider)

        if (finalized.validateEmail) {
          history.push('/email-validation')
        } else {
          history.push(redirect || '/')
        }
      }
    } catch (err) {
      throw new SubmissionError({
        _error: err.message || t('Invalid authentication code'),
      })
    }
  }

  return (
    <AuthPage className="two-factor-auth" version={2}>
      <TwoFactorAuthLoginForm onSubmit={handle2FASubmit} redirect={redirect} />
    </AuthPage>
  )
}

export default connect(null, {
  setCurrentUserToken,
  setCurrentUserAuthProvider,
})(TwoFactorAuthLogin)
